// extracted by mini-css-extract-plugin
export default {"gridContainer":"DocumentGrid_gridContainer__LWJG7","gridOverlay":"DocumentGrid_gridOverlay__EegT5"};